import { mutatorAction } from 'satcheljs';
import { getProactiveDraftsStore } from '../store/store';
import type CopilotTelemetrySession from 'owa-copilot-telemetry/lib/CopilotTelemetrySession';

const setCurrentProactiveDraftsTelemetrySessionAndUpdateCurrentMutator: (
    itemId: string | undefined,
    itemTelemetrySession: CopilotTelemetrySession | undefined
) => void = mutatorAction(
    'setCurrentProactiveDraftsTelemetrySessionAndUpdateCurrentMutator',
    function setCurrentProactiveDraftsTelemetrySessionAndUpdateCurrent(
        itemId: string | undefined,
        itemTelemetrySession: CopilotTelemetrySession | undefined
    ): void {
        if (!itemId) {
            return;
        }

        const proactiveDraftsStore = getProactiveDraftsStore();
        const proactiveDraftsState = proactiveDraftsStore.proactiveDraftsListMap.get(itemId);
        if (proactiveDraftsState) {
            proactiveDraftsState.itemTelemetrySession = itemTelemetrySession;
        }
        proactiveDraftsStore.currentTelemetrySession = itemTelemetrySession;
    }
);
export default setCurrentProactiveDraftsTelemetrySessionAndUpdateCurrentMutator;
